<template>
  <div class="my-4">
    <section-title :has-line="true" title="Documentos" />
    <div
      v-for="(item, index) in items"
      :key="`document-row-${index}`"
      class="row bg-secondary-3 rounded p-3 mb-3 ml-1 mr-0"
    >
      <div class="col-md-6">
        <div class="color-gray-6 font-14 font-weight-normal">
          Tipo de Documento:
        </div>
        <div class="color-black font-16 font-weight-normal">
          {{ item.documentTypeName }}
        </div>
      </div>
      <div class="col-md-6 d-flex">
        <span class="color-gray-6 font-14 font-weight-normal mr-3 mt-2">
          Documento:
        </span>
        <validation-provider
          v-slot="{ errors }"
          :name="item.documentTypeName"
          :rules="item.itemAttachmentId ? '' : item.rules"
        >
          <custom-file-input
            ref="attachedDocument"
            v-model="item.file"
            :accept="'.pdf'"
            :attachment-id="item.itemAttachmentId"
            custom-error-msg="Favor de anejar un documento."
            :disabled="readonly"
            display-style="normal"
            :error="errors[0]"
            label-position="left"
            :max-size="10"
            :name="item.filename"
            :on-download="downloadFile"
            required
            @after-remove="item.itemAttachmentId = null"
            @input="$emit('input')"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomFileInput from 'CustomFileInput';
import appServices from '@/modules/app/api';

export default {
  name: 'Documents',
  components: {
    SectionTitle,
    CustomFileInput,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  methods: {
    downloadFile(attachmentId) {
      if (attachmentId) {
        appServices.downloadDocumentByAttachmentId(attachmentId).catch(() => {
          this.ShowToast('', 'El documento no existe.', 'error');
        });
      }
    },
  },
};
</script>
<style scoped></style>
